import { IconButton, InputAdornment } from "@mui/material";

import DateRangeIcon from "@mui/icons-material/DateRange";

export default function DinercapDateIcon() {
    return (
        <InputAdornment position="end">
            <IconButton>
                <DateRangeIcon />
            </IconButton>
        </InputAdornment>
    );
}
